<template>
  <div class="container bottom-fix-padding">
    <v-datepicker v-show="ifDatePick" outer_opendate="10" :outer_disableddates="pick_disabledDate" :outer_date="order.data.pick_date" :outer_period="order.data.pick_period" @change="pickDateSave" @close="pickDateClose()" ></v-datepicker>
    <v-datepicker v-show="ifDateReturn" outer_opendate="90" :outer_disableddates="return_disabledDate" :outer_date="order.data.return_date" :outer_period="order.data.return_period" @change="returnDateSave" @close="returnDateClose()"></v-datepicker>
    <div class="core" v-show="!ifDatePick&&!ifDateReturn">
      <div class="navi">
          <span class="icon-arrow-left" @click="goto('/storage-intro')"></span>
      </div>
      <div class="title">行李寄存详情</div>
      <div class="notice-box" v-show="ifHoliday()">
        <div class="notice-yellow">
          {{holidayWord()}}
        </div>
      </div>
      <div class="main">
          <div class="core">
            <div class="weui-cells__title">联系信息</div>
            <div class="weui-cells weui-cells_form">
                <div class="weui-cell">
                    <div class="weui-cell__hd"><label class="weui-label">联系人</label></div>
                    <div class="weui-cell__bd">
                        <input class="weui-input" type="text" placeholder="请输入您的名字" v-model="order.data.username" >
                    </div>
                </div>
                <div class="weui-cell">
                    <div class="weui-cell__hd">
                        <label class="weui-label">联系手机</label>
                    </div>
                    <div class="weui-cell__bd">
                        <input class="weui-input" type="tel" placeholder="请输入您的手机号" v-model="order.data.userphone">
                    </div>
                </div>
                <div class="weui-cell">
                    <div class="weui-cell__hd"><label class="weui-label">备用联系</label></div>
                    <div class="weui-cell__bd">
                        <input class="weui-input" type="text" placeholder="微信号 / 中国手机号" v-model="order.data.contact_bak">
                    </div>
                </div>
            </div>

            <div class="weui-cells__title">寄存详情</div>
            <div class="weui-cells">
              <a class="weui-cell weui-cell_access" href="javascript:;"  @click="pickDateOpen()">
                  <div class="weui-cell__bd">
                      <p>取货日期</p>
                  </div>
                  <div class="weui-cell__ft" v-if="!order.data.pick_date">点击选择</div>
                  <div class="weui-cell__ft" v-else>{{order.data.pick_date | moment("YYYY年M月D日")}} {{pick_period}}</div>
              </a>
              <a class="weui-cell weui-cell_access" href="javascript:;" @click="returnDateOpen()">
                  <div class="weui-cell__bd">
                      <p>送回日期</p>
                  </div>
                  <div class="weui-cell__ft" v-if="!order.data.return_date">（如尚未确定，可以不填）</div>
                  <div class="weui-cell__ft" v-else>{{order.data.return_date | moment("YYYY年M月D日")}} {{return_period}}</div>
              </a>
            </div>
            <div class="weui-cells__title"  v-show="order.data.pick_date">寄存物品清单</div>
            <div class="weui-cells"  v-show="order.data.pick_date">
                <div class="weui-cell">
                    <div class="weui-cell__bd">
                        <p>行李件数</p>
                    </div>
                    <div class="weui-cell__ft">
                      <v-counter @plus="plus" @minus="minus" :num='order.data.baggage' ></v-counter>
                      
                    </div>
                </div>
            </div>
            <div class="weui-cells weui-cells_form" v-show="order.data.pick_date">
              <div class="weui-cell">
                  <div class="weui-cell__bd">
                      <textarea class="weui-textarea" placeholder="有其他行李物品或服务需求，请在这里填写" rows="3" v-model="order.data.msg"></textarea>
                  </div>
              </div>
            </div>
        </div>

      </div>
      <div class="btn-box-fix">
        <div class="btn-container">
          <div class="btn" @click="checkSubmit()" :class="{ active: allFilled()}" >下一步</div>
        </div>
      </div>
      <div class="js_dialog" v-show="ifUpgradePlan">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
              <div class="weui-dialog__hd"><strong class="weui-dialog__title">行李数量超额</strong></div>
              <div class="weui-dialog__bd" v-if="order.data.student_plan=='1668743923'">您的行李数即将突破 Mini 套餐的5件上限，请问是否升级为 A 套餐？</div>
              <div class="weui-dialog__bd" v-if="order.data.student_plan=='1668743953'">您的行李数即将突破 A 套餐的10件上限，请问是否升级为 B 套餐？</div>
              <div class="weui-dialog__bd" v-if="order.data.student_plan=='1668743985'">您的行李数即将突破 B 套餐的15件上限，请问是否升级为 C 套餐？</div>
              <div class="weui-dialog__bd" v-if="order.data.student_plan=='1668744048'">您的行李数已到达 C 套餐的20件上限</div>

              <div class="weui-dialog__ft" v-if="order.data.student_plan=='1668744048'">
                  <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="ifUpgradePlan=false">好的</a>
              </div>

              <div class="weui-dialog__ft" v-else>
                  <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="ifUpgradePlan=false">取消</a>
                  <div  class="weui-dialog__btn weui-dialog__btn_daojia" @click="upgradePlan()">升级套餐</div>
              </div>
          </div>
      </div>
    </div>
    <div v-show="localErrorShow">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__bd">{{localError[0]}}</div>
            <div class="weui-dialog__ft">
                <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="localErrorShow=false">好的</a>
            </div>
        </div>
    </div>
    <div v-show="isCheckPhone">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__hd"><strong class="weui-dialog__title">手机号确认</strong></div>
            <div class="weui-dialog__bd">请仔细检查手机号是否正确<div class="check-phone">{{order.data.userphone}}</div></div>
            <div class="weui-dialog__ft">
                <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_default" @click="isCheckPhone = false">返回修改</a>
                <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="orderUpdateAll('/storage-step4')">确认正确</a>
            </div>
        </div>
    </div>
    <img :src="pixelURL('cangchu','step3')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'step3',
  data () {
    return {
      order:{
        service:'storage',
        data:{
          username:"",
          userphone:"",
          pick_date:"",
          return_date:"",
          pick_period:"",
          return_period:"",
          baggage: 1,
          student_plan:'',
          pick_street: "",
          pick_suburb: "",
          pick_state: "NSW",
          pick_postcode: "",
          return_street: "",
          return_suburb: "",
          return_state: "NSW",
          return_postcode: "",
          agency: "",
          return_pending:"",
          msg:""
        },
        temp:{
          isAM:'',
          isPM:'',
          isDate:'',
          timeTable:{}
        },
      },
      pick_disabledDate: {
        to: new Date(),
        ranges: [],
      },
      return_disabledDate: {
        to: new Date(),
        ranges:[],
      },
      ifDatePick:false,
      ifDateReturn:false,
      ifUpgradePlan:false,
      localError:[],
      localErrorShow:false,
      isCheckPhone:false
    }
  },
  created: function () {
    document.querySelector("html").classList.add("grey-background");

    this.pick_disabledDate.ranges = this.DisabledDateRangesMove();
    this.return_disabledDate.ranges = this.DisabledDateRangesMove();

    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "storage"){
        this.order = localParsed;
      }
      else{
        // this.$router.push('/');
      }
    }
    else{
      // this.$router.push('/');
    }
    if(this.order.data.username==""&&localStorage.member_name){
        this.order.data.username = localStorage.member_name;
    }
    if(this.order.data.userphone==""&&localStorage.member_phone){
        this.order.data.userphone = localStorage.member_phone;
    }
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  },
  computed: {
    pick_period: function () {
      let result = '';
      switch (this.order.data.pick_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("1");
      }
      return result;
    },
    return_period: function () {
      let result = '';
      switch (this.order.data.return_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
          console.log("1");
      }
      return result;
    },
  },
  methods: {
    allFilled(){
       if(this.order.data.username &&
          this.order.data.userphone &&
          this.order.data.pick_date &&
          this.order.data.baggage){
            return true;
        }
    },
    checkSubmit(){
      this.localError = [];
      if (!this.order.data.username) {
        this.localError.push("请填写联系人名称");
      } else if (this.order.data.username.length>16) {
        this.localError.push("联系人名称过长，请填写16位以下字符长度的名称");
      }
      if (!this.order.data.userphone) {
        this.localError.push("请填写联系手机");
      } else if (this.order.data.userphone.length>11 || this.order.data.userphone.length<9) {
        this.localError.push("手机号码长度不正确，请检查是否正确");
      }
      if (!this.order.data.pick_date) {
        this.localError.push("请选择取货时间");
      }
      if (!this.order.data.baggage) {
        this.localError.push("请填写行李件数");
      } else if (this.order.data.baggage>20 || this.order.data.baggage<1) {
        this.localError.push("行李件数不正常，请填写1~20之间的数字");
      }
      if (!this.localError.length) {
        if(this.checkLogin()){
            this.orderUpdateAll('/storage-step4');
        }
        else{
            this.isCheckPhone = true;
        }
      }
      else{
        this.localErrorShow = true;
        return false;
      }
    },
    plus(){
      this.order.data.baggage = this.order.data.baggage + 1;
      let max = '';
      switch (this.order.data.student_plan) {
        case "1668743923":
          max = 5
          break;
        case "1668743953":
          max = 10
          break;
        case "1668743985":
          max = 15
          break;
        case "1668744048":
          max = 20
          break;
        default:
          console.log("1");
      }
			if(this.order.data.baggage>max){
        this.ifUpgradePlan = true;
        this.order.data.baggage = max;
			}
    },
    minus(){
      this.order.data.baggage = this.order.data.baggage - 1;
			if(this.order.data.baggage<1){
				this.order.data.baggage=1;
			}
    },
    upgradePlan(){
      this.order.data.baggage = this.order.data.baggage;
      let newPlan = '';
      switch (this.order.data.student_plan) {
        case "1668743923":
          newPlan = '1668743953'
          break;
        case "1668743953":
          newPlan = '1668743985'
          break;
        case "1668743985":
          newPlan = '1668744048'
          break;
        default:
          console.log("1");
      }
      this.order.data.student_plan = newPlan;
			this.order.data.baggage = this.order.data.baggage + 1;
      this.ifUpgradePlan = false;
    },
    pickDateClose(){
      this.ifDatePick = false;
      document.querySelector("html").classList.add("grey-background");
    },
    returnDateClose(){
      this.ifDateReturn = false;
      document.querySelector("html").classList.add("grey-background");
    },
    pickDateOpen(){
      this.ifDatePick = true;
      document.querySelector("html").classList.remove("grey-background");
      if(this.order.data.username && this.order.data.userphone){
          this.userCatch("1550735973",this.order.data.username,this.order.data.userphone);
      }
    },
    returnDateOpen(){
      this.ifDateReturn = true;
      document.querySelector("html").classList.remove("grey-background");
    },
    pickDateSave(date,period){
      this.pickDateClose();
      this.order.data.pick_date = date;
      this.order.data.pick_period = period;
    },
    returnDateSave(date,period){
      this.returnDateClose();
      this.order.data.return_date = date;
      this.order.data.return_period= period;
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.hr{
  border-top:1px solid #eee;
  margin:16pt 0;
}
.address-empty{
  color:#ccc;
  font-size:1.2em;
}

.address-detail{
  color:#666;
  font-size:1.1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.address-parking{
  color:#aaa;
  font-size:1em;
}

.arrow-right{
  color:#ddd;
}
.move-title{
  font-weight:bold;
  font-size:1.2em;
  color:#555;
  margin-bottom:4pt;
}

.waypoint{
  font-weight:bold;
  font-size:1.2em;
  color:#777;
  margin-bottom:4pt;
}

select{
  -webkit-appearance: none;
  border: 0;
  outline: 0;
  background-color: transparent;
  width: 100%;
  font-size: inherit;
  height: 45px;
  line-height: 45px;
  position: relative;
  z-index: 1;
}

.fade-enter-active{
  transition-duration: 0.5s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.check-detail{
  border: 2px solid #e3e3e3;
  padding: 8px 18px 8px 14px;
  margin-top: 14px;
  display: inline-block;
  border-radius: 50px;
}

.more-detail{
  text-align:center;
  margin-bottom:20px;
}

</style>



// WEBPACK FOOTER //
// src/pages/storage/step3.vue